import WorkflowLogExecutionContextDrawer from '@/components/modals/workflowLogsModal/WorkflowLogExecutionContextDrawer.jsx';
import { FiActivity, LuExternalLink } from '@/components/react-icons/main';
import FloatingSelectV2 from '@/components/v2/FloatingSelectV2';
import IconV2 from '@/components/v2/IconV2.jsx';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import selectors from '@/redux/selectors/selectors';
import { useState } from 'react';

const DetailsHeaderAdminActions = () => {
  const [showExecutionContext, setShowExecutionContext] = useState(false);
  const activeLogId = useArgSelector(selectors.query, 'logId');
  const log = useArgSelector(selectors.workflowLogsById, activeLogId);
  const taskInfo = log?.meta?.taskInfo;

  const encodedStreamName = encodeURIComponent(taskInfo?.logStream || '');
  const clusterName = taskInfo?.cluster?.split('/')[1];
  const serviceName = taskInfo?.logStream?.split('/')[1];
  const taskId = taskInfo?.taskId;

  const legacyClusters = {
    'webhook-runner-fargate': { logGroup: 'webhook-runner', service: 'webhook-runner-fargate-1' },
    'gravity-api-fargate': { logGroup: 'gravity-api-fargate', service: 'gravity-api-fargate-1' },
    'public-api-fargate': { logGroup: 'public-api-fargate', service: 'public-api-fargate-1' },
    'code-runner-fargate': { logGroup: 'code-runner-fargate', service: 'code-runner-fargate-service-1' }
  };
  const legacy = legacyClusters[clusterName];
  const logGroupName = legacy?.logGroup || clusterName;
  const ecsServiceName = legacy?.service || clusterName;

  const awsUrlOptions = [
    {
      label: 'View Logs in AWS',
      value: `https://us-west-1.console.aws.amazon.com/cloudwatch/home?region=us-west-1#logsV2:log-groups/log-group/%2Fecs%2F${logGroupName}/log-events/${encodedStreamName}`
    },
    {
      label: 'View Parent Task in AWS',
      value: `https://us-west-1.console.aws.amazon.com/ecs/v2/clusters/${clusterName}/services/${ecsServiceName}/tasks/${taskId}/configuration?region=us-west-1&selectedContainer=${serviceName}`
    }
  ];

  const handleAwsUrlClick = ({ value }) => {
    window.open(value, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <div className="details-header-actions">
        {log?.id && <IconV2 className={'light execution-context-link'} icon={FiActivity} onClick={() => setShowExecutionContext(true)} title={'View execution context'} />}
        {taskInfo && <IconV2 className={'light aws-links'} icon={LuExternalLink} title={'View in AWS'} />}
      </div>
      {taskInfo && <FloatingSelectV2 triggers={['.aws-links']} options={awsUrlOptions} useSearch={false} onChange={handleAwsUrlClick} />}
      <WorkflowLogExecutionContextDrawer show={showExecutionContext} workflowLogId={log?.id} onHide={() => setShowExecutionContext(false)} />
    </>
  );
};

export default DetailsHeaderAdminActions;
